import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { UtilityClient, WebSelectionItem, WebSwoDeliveryRequest, OneTimePaymentRequest, WebNotificationSettings } from "src/app/models";

@Injectable({
    providedIn: "root",
})
export class UtilityService
{

    private phoneDescriptionSubject = new BehaviorSubject<WebSelectionItem[]>([]);
    public phoneDescriptions: Observable<WebSelectionItem[]> = this.phoneDescriptionSubject.asObservable();


    constructor(
        private utilityClient: UtilityClient,
    )
    {
        this.populatePhoneDescriptions();
    }


    public sendPendingDeliveryEmail(webRequest: WebSwoDeliveryRequest): void
    {
        this.utilityClient.requestPendingDeliveryEmail(webRequest).subscribe();
    }

    public sendAutopayEmails(webRequest: WebSwoDeliveryRequest): Observable<boolean>
    {
        return this.utilityClient.sendAutopayEmails(webRequest);
    }

    public sendChaseEmailReceipt(otp: OneTimePaymentRequest)
    {
        return this.utilityClient.sendChaseEmailReceipt(otp);
    }

    public sendNotificationsEmail(notificationSettings: WebNotificationSettings): Observable<boolean>
    {
        return this.utilityClient.writeContactNotificationWeb(notificationSettings);
    }

    public sendAutopayCancellationEmails(webRequest: WebSwoDeliveryRequest): Observable<boolean>
    {
        return this.utilityClient.sendAutopayCancellationEmails(webRequest);
    }

    public populatePhoneDescriptions(): void
    {
        this.utilityClient.getPhoneDescriptions().subscribe(p => this.phoneDescriptionSubject.next(p));
    }

    public writeServiceWorkOrder(swo: WebSwoDeliveryRequest): void
    {
        this.utilityClient.writeServiceWorkOrder(swo).subscribe();
    }

    public writeManualDelivery(delivery: WebSwoDeliveryRequest): void
    {
        this.utilityClient.writeManualDelivery(delivery).subscribe();
    }


}
